export default __webpack_public_path__ + "static/Geek-888bd22833580c6ef702020bd70340d2.png";